import { render, staticRenderFns } from "./ArchiveSummarySalesTable.vue?vue&type=template&id=0632e31f&scoped=true&"
import script from "./ArchiveSummarySalesTable.vue?vue&type=script&lang=js&"
export * from "./ArchiveSummarySalesTable.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveSummarySalesTable.vue?vue&type=style&index=0&id=0632e31f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0632e31f",
  null
  
)

component.options.__file = "ArchiveSummarySalesTable.vue"
export default component.exports